import React from 'react'

import { ArgIcon } from 'components/common/ArgIcon'
import useMetadata from 'hooks/use-metadata'
import theme from 'theme'
import { AttackCommandConfiguration } from 'types/api/attacks/details/targeting'
import { Metadata } from 'types/metadata'
import { getArgDisplayData } from 'utils/metadata'

export const AttackArguments: React.FC<{
  commandConfig: AttackCommandConfiguration
  metadata?: Metadata
}> = ({ commandConfig, metadata }) => {
  const { metadata: metadataFromHook } = useMetadata()

  const displayableArgs = getArgDisplayData(
    commandConfig,
    metadata ?? metadataFromHook
  ).reverse()

  return (
    <div
      css={{
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: theme.space[2],
        marginLeft: theme.space[2]
      }}
    >
      {displayableArgs.map((arg, i) => (
        <ArgIcon
          key={i}
          css={{
            marginLeft: -theme.space[2],
            marginTop: -theme.space[2],
            zIndex: i
          }}
          icon={arg.infraCommandArgKey}
          tooltip={`${arg.name}: ${arg.value}`}
        />
      ))}
    </div>
  )
}
